import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
}) => {
  const {
    spacing,
  } = theme;

  return {
    default: {
      header: {
        display: 'flex',
        flexDirection: 'column',
      },
      save: {
        flex: 1,
        marginTop: gu2px(1, spacing),
        opacity: 0,
        maxHeight: 0,
        transition: 'opacity 0.3s ease-in-out, max-height 0.3s ease-in-out',
      },
    },

    tablet: {
      header: {
        flexDirection: 'row',
        alignItems: 'center',
      },
      save: {
        maxHeight: 'auto',
        marginLeft: gu2px(2, spacing),
        marginTop: 0,
        textAlign: 'right',
      },
    },

    dirty: {
      save: {
        opacity: 1,
        maxHeight: 60,
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/presentation/components/inline-privacy/InlinePrivacy.stylesheet.js